import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const SendGoodbyeEmailEvent = BaseLoanEvent.extend({
  type: z.literal('sendGoodbyeEmail'),
  isUpdate: z.boolean().optional(),
});
export type SendGoodbyeEmailEvent = z.infer<typeof SendGoodbyeEmailEvent>;
